module.exports = __webpack_public_path__ + "media/click.ab5ac977.ogg";